import { Col } from "react-bootstrap";
import "../../timeline.css";
import ShareOption from "../../../Shareoption";
import ShareModel from "../../../Sharemodel";
import { images } from "../../../../constants";
import { getAsset } from "../../../../helpers/helper";
import Photovideoupdate from "../../../Update_timelinepost/index.js";
import Subscriptionmdl from "../../../subscription_modal/index.js";
import PostItem from "../../../Post_item/index.js";
import timelineone from "../../../../assets/images/dummy/timelineone.png";
import timelinetwo from "../../../../assets/images/dummy/timelinetwo.png";
import { useViewPostState } from "../../../../hooks/useViewPostState";
import Modal from "@/components/ui/modal/modal";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Skeleton card shown while timeline API is loading
const TimelineSkeletonCard = () => (
  <Col
    lg="12"
    xl="12"
    md="12"
    sm="12"
    xs="12"
    className="mt-3 bg-white p-3 rounded"
    style={{ boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.1)", margin: "1px" }}
  >
    <div className="d-flex align-items-center mb-3">
      <Skeleton circle width={44} height={44} className="me-2" />
      <div style={{ flex: 1 }}>
        <Skeleton width={120} height={14} />
        <Skeleton width={80} height={11} className="mt-1" />
      </div>
    </div>
    <Skeleton height={180} className="mb-2" />
    <Skeleton count={2} height={12} className="mb-1" />
    <div className="d-flex justify-content-between mt-2">
      <Skeleton width={55} height={28} />
      <Skeleton width={55} height={28} />
      <Skeleton width={70} height={28} />
      <Skeleton width={55} height={28} />
    </div>
  </Col>
);

const Viewpost = ({
  rightSide,
  mysetting,
  createPost,
  timelineid,
  getTimelinePosts,
  getmyTimeline,
  setGetmyTimeline,
  id,
  post_ID,
  getbusinesstype,
  shareTimeline,
  setShareTimeline,
  sharedToOtherTimeline,
  mybusinessType,
  timelineLoading,
  onShareSuccess,
}) => {
  const {
    // state
    name,
    comment,
    modalopen,
    setModalopen,
    shows,
    setShows,
    postId,
    setPostId,
    postLikes,
    postDislikes,
    postStatus,
    showshare,
    openCommentPostId,
    setOpenCommentPostId,
    showmodal,
    shareurl,
    comments,
    composerIdentity,
    resolveCommentIdentity,
    sharetoOthers,
    shareOriginShopId,
    updatepost,
    setUpdatepost,
    dummyImages,
    lgShow,
    setLgShow,
    purchase,
    setPurchase,
    updatedata,
    setUpdatedata,
    // handlers
    handleCommentClick,
    handleClosemodal,
    handleClose,
    handleShowshare,
    handleShowShareModal,
    handleCloseshare,
    handleClick,
    Deleteitem,
    handleCommentChange,
    getTimelineComments,
    handleSubmit,
    getShareTimeline,
    UpdatePost,
  } = useViewPostState({
    id,
    timelineid,
    mysetting,
    getbusinesstype,
    mybusinessType,
    getTimelinePosts,
    setGetmyTimeline,
    setShareTimeline,
    getmyTimeline,
    shareTimeline,
    sharedToOtherTimeline,
  });

  const dummyImageSources = [
    { src: timelineone, key: "dummy-1" },
    { src: timelinetwo, key: "dummy-2" },
  ];

  const renderItems = () => {
    const items = [];
    const normalize = (str) =>
      (str || "").toLowerCase().replace(/[\s_-]+/g, "");

    const pushOwnPost = (post) => {
      if (!post?._id) return;
      items.push(
        <PostItem
          key={`own-${post._id}`}
          post={post}
          name={name}
          images={images}
          mysetting={mysetting}
          modalopen={modalopen}
          setModalopen={setModalopen}
          setPostId={setPostId}
          Deleteitem={Deleteitem}
          setShows={setShows}
          setUpdatepost={setUpdatepost}
          postLikes={postLikes}
          postDislikes={postDislikes}
          postStatus={postStatus}
          handleClick={handleClick}
          handleCommentClick={handleCommentClick}
          getTimelineComments={getTimelineComments}
          openCommentPostId={openCommentPostId}
          id={id}
          comment={comment}
          comments={comments}
          composerIdentity={composerIdentity}
          resolveCommentIdentity={resolveCommentIdentity}
          handleCommentChange={handleCommentChange}
          handleSubmit={handleSubmit}
          getShareTimeline={getShareTimeline}
          handleOpenShareModal={handleShowShareModal}
          getAsset={getAsset}
          setOpenCommentPostId={setOpenCommentPostId}
        />,
      );
    };

    const pushSharedPost = (entry) => {
      const post = entry?.postid;
      if (!post?._id) return;
      const sharedPost = entry?.createdAt
        ? { ...post, createdAt: entry.createdAt, timeAgo: undefined }
        : post;

      // Author = who SHARED (sender), never the destination shop.
      const shopImgList = (shop) => {
        if (!shop || typeof shop !== "object") return null;
        const raw = shop.image || shop.imageUrl;
        if (!raw) return null;
        return Array.isArray(raw) ? raw.filter(Boolean) : [raw];
      };
      const senderShop =
        entry?.sharebyshopid && typeof entry.sharebyshopid === "object"
          ? entry.sharebyshopid
          : null;
      const senderUser =
        entry?.sharebyshopuserid && typeof entry.sharebyshopuserid === "object"
          ? entry.sharebyshopuserid
          : null;
      const senderBT = normalize(entry?.senderBusinessType || "");
      // User-profile / GP share → username. Shop-page share → shop name.
      const sharedAsPerson =
        senderBT === "generalpublic" ||
        senderBT === "" ||
        !entry?.sharebyshopid;

      let displayName = "";
      let displayImg = null;

      if (
        !sharedAsPerson &&
        (senderShop?.shopname ||
          senderShop?.profileName ||
          senderShop?.companyname)
      ) {
        displayName =
          senderShop.shopname ||
          senderShop.profileName ||
          senderShop.companyname;
        displayImg = shopImgList(senderShop);
      } else {
        displayName = senderUser?.fullname || name?.fullname || "";
        displayImg = senderUser?.imageUrl || name?.imageUrl || null;
      }

      items.push(
        <PostItem
          key={`share-${entry._id || post._id}`}
          post={sharedPost}
          name={name}
          images={images}
          mysetting={mysetting}
          modalopen={modalopen}
          setModalopen={setModalopen}
          setPostId={setPostId}
          Deleteitem={Deleteitem}
          setShows={setShows}
          setUpdatepost={setUpdatepost}
          postLikes={postLikes}
          postDislikes={postDislikes}
          postStatus={postStatus}
          handleClick={handleClick}
          handleCommentClick={handleCommentClick}
          getTimelineComments={getTimelineComments}
          openCommentPostId={openCommentPostId}
          id={id}
          comment={comment}
          comments={comments}
          composerIdentity={composerIdentity}
          resolveCommentIdentity={resolveCommentIdentity}
          handleCommentChange={handleCommentChange}
          handleSubmit={handleSubmit}
          getShareTimeline={getShareTimeline}
          handleOpenShareModal={handleShowShareModal}
          getAsset={getAsset}
          setOpenCommentPostId={setOpenCommentPostId}
          fullname={displayName}
          imgurl={displayImg}
          isShared
        />,
      );
    };

    const received = (shareTimeline || []).filter((entry) => {
      const senderId = String(
        entry?.sharebyshopuserid?._id || entry?.sharebyshopuserid || "",
      );
      const recipientUserId = String(
        entry?.sharetoshopuserid?._id || entry?.sharetoshopuserid || "",
      );
      const currentId = String(name?._id || "");
      if (
        currentId &&
        senderId === currentId &&
        recipientUserId === currentId
      ) {
        return false;
      }
      return true;
    });
    const sent = sharedToOtherTimeline || [];
    const sentSet = new Set(sent);
    const combined = [...sent, ...received];
    const tabBT = normalize(mysetting);
    const uniqueIds = new Set();

    const entryPostId = (entry) =>
      entry?.postid?._id?.toString() || entry?.postid?.toString() || "";
    const entryTargetShopId = (entry) => {
      const shop = entry?.sharetoshopid;
      if (!shop) return "";
      return String(shop._id || shop);
    };

    const isPersonalProfilePage = !id;
    const pageShopBT = normalize(mybusinessType || "");
    const entrySenderBT = (entry) =>
      normalize(
        entry?.senderBusinessType ||
          entry?.senderprofileType ||
          entry?.postid?.businessType ||
          "",
      );
    // Do NOT default missing businessType to generalPublic — that wrongly
    // put shop-origin shares on the General Public tab.
    const entryDestBT = (entry) => normalize(entry?.businessType || "");
    const entryFromShopId = (entry) => {
      const shop = entry?.sharebyshopid;
      if (!shop) return "";
      return String(shop._id || shop);
    };
    // True GP-only person share (not a shop-area share stamped from /user-profile).
    const isPersonOriginShare = (entry) => {
      const from = entrySenderBT(entry);
      const dest = entryDestBT(entry);
      const noShopAuthor = !entry?.sharebyshopid;
      const isShopArea =
        (dest && dest !== "generalpublic" && dest !== "marketerprofile") ||
        (from && from !== "generalpublic" && from !== "marketerprofile");
      // Shop-targeted shares from /user-profile must stay on that shop tab.
      if (noShopAuthor && isShopArea) return false;
      return noShopAuthor && (!from || from === "generalpublic");
    };

    const soft = (a, b) => {
      if (!a || !b) return false;
      if (a === b) return true;
      if (a.includes(b) || b.includes(a)) return true;
      const strip = (s) =>
        s.replace(/(shop|profile|store|area|business)$/g, "");
      return strip(a) === strip(b);
    };

    const belongsOnTab = (entry) => {
      if (!entry) return false;
      const isSentRow = sentSet.has(entry);
      if (isPersonalProfilePage && isSentRow) {
        return false;
      }

      const destBT = entryDestBT(entry);
      const fromBT = entrySenderBT(entry);

      const rawPostBt = normalize(entry?.postid?.businessType || "");
      const isMarketerShareEntry =
        destBT === "marketerprofile" ||
        fromBT === "marketerprofile" ||
        rawPostBt === "marketerprofile" ||
        entry?.postid?.bymarketer === true ||
        entry?.bymarketer === true ||
        (entry?.postid?.marketerid && entry?.postid?.marketerid !== "N/A");

      if (isMarketerShareEntry) {
        return tabBT === "marketerprofile";
      }

      const personOrigin = isPersonOriginShare(entry);
      const targetShop = entryTargetShopId(entry);
      const fromShop = entryFromShopId(entry);
      const toThisShop =
        !!id && !!targetShop && String(targetShop) === String(id);
      const sentFromThisShop =
        !!id && !!fromShop && String(fromShop) === String(id);

      if (isPersonalProfilePage) {
        // If shared FROM a specific profile/shop area (fromBT !== "generalpublic"),
        // display on the tab of the profile where it was shared from.
        if (fromBT && fromBT !== "generalpublic") {
          return soft(tabBT, fromBT);
        }
        // If shared TO a specific area (destBT !== "generalpublic"),
        // display on that destination tab.
        if (destBT && destBT !== "generalpublic") {
          return soft(tabBT, destBT);
        }
        // Otherwise (shared from General Public), show on General Public tab.
        return tabBT === "generalpublic";
      }

      // ── Shop profile page ──
      // SENT from this shop → show on this shop's own area tab or GP if target is GP
      if (isSentRow || sentFromThisShop) {
        if (fromBT && fromBT !== "generalpublic" && soft(tabBT, fromBT))
          return true;
        if (tabBT === "generalpublic") {
          return destBT === "generalpublic";
        }
        if (pageShopBT && soft(tabBT, pageShopBT)) return true;
        return !pageShopBT;
      }

      // Destination shop: a connected shop shared onto us → display the post
      // on the tab of the area it was shared FROM (sender's area), only there.
      if (
        entry?.sharebyshopid &&
        fromShop &&
        String(fromShop) !== String(id || "") &&
        toThisShop
      ) {
        if (fromBT && soft(tabBT, fromBT)) return true;
        if (tabBT === "generalpublic") return destBT === "generalpublic";
        return false;
      }

      if (personOrigin) {
        if (fromBT && fromBT !== "generalpublic" && soft(tabBT, fromBT)) {
          return true;
        }
        if (destBT && destBT !== "generalpublic") {
          return soft(tabBT, destBT);
        }
        if (tabBT === "generalpublic") {
          return !destBT || destBT === "generalpublic";
        }
        return false;
      }

      if (fromBT && fromBT !== "generalpublic" && soft(tabBT, fromBT)) {
        return true;
      }

      if (tabBT === "generalpublic") {
        return (
          (!fromBT || fromBT === "generalpublic") &&
          (destBT === "generalpublic" || !destBT)
        );
      }

      return destBT === tabBT || (fromBT && fromBT === tabBT);
    };

    const uniqueTabPosts =
      mysetting === "home"
        ? []
        : combined
            .filter((entry) => {
              if (!entry?.postid) return false;
              // Need a populated post object to render the card.
              if (typeof entry.postid !== "object" || !entry.postid._id) {
                return false;
              }
              if (!belongsOnTab(entry)) return false;
              const pid = entryPostId(entry);
              if (!pid || uniqueIds.has(pid)) return false;
              uniqueIds.add(pid);
              return true;
            })
            .sort((a, b) => {
              const dateA = new Date(a?.postid?.createdAt || a?.createdAt || 0);
              const dateB = new Date(b?.postid?.createdAt || b?.createdAt || 0);
              return dateB - dateA;
            });

    if (mysetting === "home") {
      // My Timeline = posts you created matching the current profile context (never shared posts).
      (getmyTimeline || []).forEach((post) => {
        const rawBt =
          post?.businessType || (id ? mybusinessType : "generalPublic");
        const pbt = normalize(rawBt || "");
        if (!id && mybusinessType) {
          const targetBt = normalize(mybusinessType);
          if (targetBt === "marketerprofile") {
            if (pbt !== "marketerprofile" && !post?.bymarketer) return;
          } else if (targetBt === "generalpublic") {
            if (pbt === "marketerprofile" || post?.bymarketer) return;
          }
        }
        pushOwnPost(post);
      });
    } else {
      // Area tabs (General Public / Retailer / Marketer Profile / …):
      // On shop pages (id exists), include own shop posts. On personal profiles, own posts stay on My Timeline.
      if (id) {
        (getmyTimeline || []).forEach((post) => {
          const rawBt = post?.businessType || mybusinessType;
          const pbt = normalize(rawBt || "");
          if (tabBT === "marketerprofile") {
            if (pbt === "marketerprofile" || post?.bymarketer) {
              const pid = post?._id?.toString() || post?.toString();
              if (pid && !uniqueIds.has(pid)) {
                uniqueIds.add(pid);
                pushOwnPost(post);
              }
            }
            return;
          }
          if (pbt && (pbt === tabBT || soft(pbt, tabBT))) {
            const pid = post?._id?.toString() || post?.toString();
            if (pid && !uniqueIds.has(pid)) {
              uniqueIds.add(pid);
              pushOwnPost(post);
            }
          }
        });
      }
      uniqueTabPosts.forEach((entry) => pushSharedPost(entry));
    }

    // Add dummy images to fill up to 2 slots — only when NOT loading
    const totalRenderedPosts = items.length;
    const actualDummyImagesNeeded = Math.max(0, 2 - totalRenderedPosts);

    if (!timelineLoading) {
      Array.from({ length: actualDummyImagesNeeded }).forEach((_, index) => {
        const dummy = dummyImageSources[index % dummyImageSources.length];
        items.push(
          <Col
            lg="12"
            xl="12"
            md="12"
            sm="12"
            xs="12"
            className="mt-3 position-relative bg-white p-3 rounded"
            key={`dummy-${index}`}
            style={{
              boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
              margin: "1px",
            }}
          >
            <div className="post-item-dummy">
              <img
                src={dummy.src}
                alt="Dummy Post"
                style={{
                  objectFit: "cover",
                  height: "100%",
                  width: "100%",
                  borderRadius: "6px",
                }}
              />
            </div>
          </Col>,
        );
      });
    }

    return items;
  };

  return (
    <>
      <Subscriptionmdl
        lgShow={lgShow}
        setLgShow={setLgShow}
        setPurchase={setPurchase}
        purchase={purchase}
        id={id}
        getbusinesstype={getbusinesstype}
      />
      {/* share muzzamal timeline */}
      <ShareOption
        id={id}
        postId={postId}
        timelineid={timelineid}
        sharetoOthers={sharetoOthers}
        originShopId={shareOriginShopId}
        showshare={showshare}
        mybusinessType={mybusinessType}
        handleCloseshare={handleCloseshare}
        refetchTimeline={getTimelinePosts}
        onShareSuccess={onShareSuccess}
      />

      <ShareModel
        show={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        shareurl={shareurl}
      />

      <Photovideoupdate
        UpdatePost={UpdatePost}
        show={updatepost}
        setUpdatepost={setUpdatepost}
        timelineid={timelineid}
        id={id}
        postId={postId}
        updatedata={updatedata}
        setUpdatedata={setUpdatedata}
      />

      {shows && (
        <Modal
          variant="deleteModal"
          shows={shows}
          title="Timeline Post"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
          postId={postId}
        />
      )}
      <Col xl="11" lg="11" md="8" sm="8" xs="10" className="mt-2 mb-2">
        <div className="d-flex justify-content-md-between justify-content-lg-center position-relative mt-2 mb-2 ps-2 pe-2 ps-lg-0 pe-lg-0 w-100">
          <img className="subscriptionimg" src={images?.gh}></img>
          <button
            className="btn btn-primary w-100"
            onClick={() => setLgShow(true)}
          >
            View Subscription plan
          </button>
        </div>
      </Col>
      <Col lg="11">
        <div
          className={`noscroll ${
            Number(rightSide) >= 10 ? "timelinescrollTwo" : "timelinescroll"
          }`}
        >
          {timelineLoading ? (
            // Show skeleton cards while API is pending
            <>
              <TimelineSkeletonCard />
              <TimelineSkeletonCard />
            </>
          ) : (
            renderItems()
          )}
        </div>
      </Col>
    </>
  );
};

export default Viewpost;
